import { h } from 'preact'
import { attributesAnalytics } from '../../js/modules/component'

export const ReassuranceReseau = ({ title, image, alt, description, CTA, cacheKey }) => {
   return (
      <div
         class="lien-composite reassurance-reseau py-0"
         data-testid="bande-reassurance-reseau"
         data-cache-key={cacheKey}
         {...attributesAnalytics(CTA.analytics)}
      >
         <img src={`${image}?saveas=webp`} alt={alt} loading="lazy" class="bg-img" />
         <div class="container-fluid bloc-txt">
            <div class="row">
               <div class="col-12 col-md-8 col-lg-6 mt-2 mb-2 text-white">
                  <h2 class="h3 mb-1">{title}</h2>
                  <p class="w-50 w-md-75 lead mb-0">{description}</p>
               </div>
               <div class="col-12 text-center text-sm-left mb-2">
                  <a href={CTA.URL} aria-label={`${CTA.label} : ${CTA.ariaLabel}`} class="btn btn-primary btn-inverse">
                     {CTA.label}
                  </a>
               </div>
            </div>
         </div>
      </div>
   )
}
